
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/colocation",
      function () {
        return require("private-next-pages/colocation.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/colocation"])
      });
    }
  